import { render, staticRenderFns } from "./modalAsignarTablero.vue?vue&type=template&id=42c8022c&scoped=true"
import script from "./modalAsignarTablero.vue?vue&type=script&lang=js"
export * from "./modalAsignarTablero.vue?vue&type=script&lang=js"
import style0 from "./modalAsignarTablero.vue?vue&type=style&index=0&id=42c8022c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8022c",
  null
  
)

export default component.exports